module.exports = __webpack_public_path__ + "static/img/bottom_bg_right.ce6b234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bottom_bg_right.png
// module id = kbjj
// module chunks = 1